// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__12CG7","colMaxWidth":"Table_colMaxWidth__1k-Ks"};